import PropTypes from "prop-types";

import { defineMessages, injectIntl } from "react-intl";

import classNames from "classnames";

import ImmutablePureComponent from "react-immutable-pure-component";

import { length } from "stringz";

import Button from "flavours/glitch/components/button";
import { Icon } from "flavours/glitch/components/icon";
import { maxChars } from "flavours/glitch/initial_state";

import CharacterCounter from "./character_counter";

const messages = defineMessages({
  publish: {
    defaultMessage: "Post",
    id: "compose_form.publish",
  },
  schedule: { id: "compose_form.schedule", defaultMessage: "Schedule" },
  saveChanges: { id: "compose_form.save_changes", defaultMessage: "Save changes" },
  public: { id: "privacy.public.short", defaultMessage: "Public" },
  unlisted: { id: "privacy.unlisted.short", defaultMessage: "Unlisted" },
  private: { id: "privacy.private.short", defaultMessage: "Followers only" },
  direct: { id: "privacy.direct.short", defaultMessage: "Mentioned people only" },
});

class Publisher extends ImmutablePureComponent {

  static propTypes = {
    countText: PropTypes.string,
    disabled: PropTypes.bool,
    intl: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
    privacy: PropTypes.oneOf(["direct", "private", "unlisted", "public"]),
    isEditing: PropTypes.bool,
    scheduled: PropTypes.bool,
  };

  handleSubmit = () => {
    this.props.onSubmit();
  };

  render () {
    const { countText, disabled, intl, privacy, isEditing, scheduled } = this.props;

    const diff = maxChars - length(countText || "");
    const computedClass = classNames("compose-form__publish", {
      disabled: disabled,
      over: diff < 0,
    });

    let publishText;
    if (isEditing) {
      publishText = intl.formatMessage(messages.saveChanges);
    } else if (scheduled) {
      publishText = (
        <>
          <Icon id='clock' />
          <span>{intl.formatMessage(messages.schedule)}</span>
        </>
      );
    } else {
      // The visibility shows on its button in the toolbar, so the label stays the same.
      publishText = intl.formatMessage(messages.publish);
    }

    const privacyNames = {
      public: messages.public,
      unlisted: messages.unlisted,
      private: messages.private,
      direct: messages.direct,
    };

    return (
      <div className={computedClass}>
        <CharacterCounter text={countText || ""} max={maxChars} />
        <Button
          className='primary'
          text={publishText}
          title={`${intl.formatMessage(messages.publish)}: ${intl.formatMessage(privacyNames[privacy])}`}
          onClick={this.handleSubmit}
          disabled={disabled}
        />
      </div>
    );
  }

}

export default injectIntl(Publisher);
